/**
 * KpiStrip — the 4-tile KPI row for Documents, built on the shared `StatTile`.
 * Total documents · added this month · storage used · folders.
 */
import { FileText, Upload, HardDrive, FolderOpen } from "lucide-react";
import { StatTile } from "../../master-list/index.ts";
import { formatBytes } from "../lib/format.ts";

export interface DocumentsKpis {
  total: number;
  addedLast30d: number;
  storageBytes: string;
  folders: number;
}

export function KpiStrip({ total, addedLast30d, storageBytes, folders }: DocumentsKpis) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <StatTile
        label="Total documents"
        value={total.toLocaleString("en-IN")}
        meta={total === 1 ? "1 file on record" : "files on record"}
        tone="sky"
        icon={FileText}
      />
      <StatTile
        label="Added this month"
        value={addedLast30d.toLocaleString("en-IN")}
        meta="uploaded in last 30d"
        tone="ok"
        icon={Upload}
      />
      <StatTile
        label="Storage used"
        value={formatBytes(storageBytes)}
        meta="across all folders"
        tone="warn"
        icon={HardDrive}
        placeholder={Number(storageBytes) === 0}
      />
      <StatTile
        label="Folders"
        value={folders.toLocaleString("en-IN")}
        meta={folders === 0 ? "none yet" : "organising your files"}
        tone="muted"
        icon={FolderOpen}
        placeholder={folders === 0}
      />
    </div>
  );
}
